import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { CryptoService } from './crypto.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { BasicResponse } from '../models/basic-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(public storageService: StorageService, public router: Router, private cryptoService: CryptoService, private httpService: HttpClient) {

  }

  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  loginChanged(isLoggedIn: boolean) {
    this.loggedIn.next(isLoggedIn);
  }

  saveTokens(access_token: string, refresh_token: string) {
    this.storageService.token = access_token;
    this.storageService.refreshToken = refresh_token;
    let decodedToken = this.cryptoService.getDecodedAccessToken();
    this.storageService.firstName = decodedToken.unique_name;
    this.storageService.lastName = decodedToken.given_name;
    this.storageService.email = decodedToken.email;
    this.loginChanged(true);
  }

  async logoutAndRedirect(callApi: boolean = true) {
    this.loginChanged(false);
    if(callApi)
      await this.logout();
    let deviceId = this.storageService.deviceId;
    localStorage.clear();
    if(deviceId)
      this.storageService.deviceId = deviceId;
    this.router.navigateByUrl("/login");
  }
  async logoutExecute(){
    this.loginChanged(false)
    localStorage.clear()
  }

  async logout() : Promise<BasicResponse>
  {
    const deviceId = `${this.storageService.deviceId}-${this.storageService.email}`;
    let apiUrl = environment.apiUrl + "/api/Users/Logout";
    let body = {
      deviceId
    };
    return await lastValueFrom(this.httpService.post<BasicResponse>(apiUrl, body));
  }
}
